import { useMemo, useState } from "react";
import { SupportedLanguage } from "@/lib/i18n/config";

export interface LocalizationState {
    currentLanguage?: string;
    languagesList: SupportedLanguage[];
    isI18nReady: boolean;
    setCurrentLanguage: (language: string) => void;
    setLanguagesList: (languages: SupportedLanguage[]) => void;
    setIsI18nReady: (ready: boolean) => void;
}

export const useLocalizationState = (): LocalizationState => {
    const [currentLanguage, setCurrentLanguage] = useState<string>();
    const [languagesList, setLanguagesList] = useState<SupportedLanguage[]>([]);
    const [isI18nReady, setIsI18nReady] = useState<boolean>(false);

    return useMemo(() => ({
        setCurrentLanguage,
        setLanguagesList,
        setIsI18nReady,
        currentLanguage,
        languagesList,
        isI18nReady,
    }), [currentLanguage, languagesList, isI18nReady]);
}